import React, { useState } from 'react';

const faqs = [
  {
    q: 'Is the AI voice detectable?',
    a: 'CallPilot uses state-of-the-art neural TTS. Most respondents engage naturally. We also support full disclosure mode where the AI identifies itself.',
  },
  {
    q: 'What happens if nobody answers?',
    a: 'CallPilot retries automatically based on your settings. You only pay for connected call time.',
  },
  {
    q: 'How is this different from robocalls?',
    a: 'Every CallPilot interaction is conversational — the AI listens, adapts, and responds. It is not a pre-recorded message.',
  },
  {
    q: 'Is this TCPA compliant?',
    a: 'Yes. CallPilot has built-in consent tracking, DNC list management, and complies with the January 2025 one-to-one consent rule.',
  },
  {
    q: 'Can I use my own voice/brand?',
    a: 'Voice customization is available on Growth and Pro plans. Voice cloning coming soon.',
  },
  {
    q: 'What AI models power this?',
    a: 'CallPilot uses best-in-class models for each task — neural TTS for voice, real-time STT for transcription, and LLMs for understanding and response generation.',
  },
];

export function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 px-6">
      <div className="mx-auto max-w-2xl">
        <div className="text-center mb-12">
          <span className="text-xs font-mono tracking-widest uppercase text-indigo-400 mb-3 block">FAQ</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
            Common questions
          </h2>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl border border-white/[0.08] bg-white/[0.03] overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left text-sm font-medium text-white hover:text-zinc-200 transition-colors"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span>{faq.q}</span>
                <svg
                  className={`w-4 h-4 text-zinc-500 transition-transform shrink-0 ml-4 ${open === i ? 'rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {open === i && (
                <div className="px-5 pb-4 text-sm text-zinc-400 leading-relaxed border-t border-white/[0.06] pt-3">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
